<section class="go-container">
  <go-card class="go-column go-column--100" id="implementing-table-searching">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Implementing Table Searching</h2>
      <go-copy cardId="implementing-table-searching" goCopyCardLink></go-copy>
    </ng-container>
    <div class="go-container" go-card-content>

      <div class="go-column go-column--100">
        <p class="go-body-copy">
          By default, searching is disabled. To enable searching, you may pass an <code class="code-block--inline">GoTableSearchConfig</code>
          class to the <code class="code-block--inline">searchConfig</code> property on the <code class="code-block--inline">GoTableConfig</code> object.
        </p>
  
        <code [highlight]="tableSearchConfig"></code>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">debounce</h4>
        <p class="go-body-copy">
          This property determines how long to wait between search changes to trigger the <code class="code-block--inline">(tableChange)</code> event.
          By default it is set to 500ms. It is recommended to not change this.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">placeholder</h4>
        <p class="go-body-copy">
          This property will set the placeholder of the search input to whatever string it passed in. This is helpful for translations.
          This property is set to <code class="code-block--inline">'Search...'</code> by default.
        </p>
      </div>

      <div class="go-column go-column--100">
        <h4 class="go-heading-4">searchable</h4>
        <p class="go-body-copy">
          This property determines whether the table is searchable.
        </p>
      </div>

      <div class="go-column go-column--100 go-column--no-padding">
        <h4 class="go-heading-4">searchTerm</h4>
        <p class="go-body-copy">
          This is the term that is being searched for. This is useful when implementing server side integration, as it is emitted
          as part of the <code class="code-block--inline">GoTableConfig</code> object and can be used for server side filtering.
          <br/>
          <caption>See <a class="go-link" [routerLink]="['../server-integration']">Server Integration</a> for more details.</caption>
        </p>
      </div>

    </div>
  </go-card>

  <go-card class="go-column go-column--100" id="setting-up-searching">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Setting up Searching</h2>
      <go-copy cardId="setting-up-searching" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <h4 class="go-heading-4">example.html</h4>
      <code [highlight]="tableConfigEx_html"></code>
      <h4 class="go-heading-4">example.ts</h4>
      <code [highlight]="tableConfigEx" class="code-block--no-bottom-margin"></code>
    </ng-container>
  </go-card>

  <go-table
    class="go-column go-column--100"
    [tableConfig]="tableConfig"
    tableTitle="Example of Table Searching">
    <go-table-column field="id" title="ID"></go-table-column>
    <go-table-column field="name.first" title="First Name"></go-table-column>
    <go-table-column field="name.last" title="Last Name"></go-table-column>
    <go-table-column field="email" title="Email"></go-table-column>
    <go-table-column field="gender" title="Gender"></go-table-column>
    <go-table-column field="ip_address" title="IP Address"></go-table-column>
  </go-table>

  <go-card class="go-column go-column--100" id="restricting-by-columns">
    <ng-container go-card-header>
      <h2 class="go-heading-2 go-heading--no-wrap">Restricting by Column</h2>
      <go-copy cardId="restricting-by-columns" goCopyCardLink></go-copy>
    </ng-container>
    <ng-container go-card-content>
      <p class="go-body-copy">
        This approach will only affect client side searches.
      </p>
      <h4 class="go-heading-4">example.html</h4>
      <code [highlight]="tableConfigRestrictColumn_html"></code>
      <h4 class="go-heading-4">example.ts</h4>
      <code [highlight]="tableConfigEx" class="code-block--no-bottom-margin"></code>
    </ng-container>
  </go-card>

  <go-table
    class="go-column go-column--100"
    [tableConfig]="tableConfig"
    tableTitle="Restricting Search By Column">
    <go-table-column field="id" title="ID"></go-table-column>
    <go-table-column field="name.first" title="First Name"></go-table-column>
    <go-table-column field="name.last" title="Last Name"></go-table-column>
    <go-table-column field="email" title="Email"></go-table-column>
    <go-table-column field="gender" title="Gender" [searchable]="false"></go-table-column>
    <go-table-column field="ip_address" title="IP Address" [searchable]="false"></go-table-column>
  </go-table>
</section>
